import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {fas} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";

export default function ProjectListCreateLink() {

    let {t} = useTranslation();
    let navigate = useNavigate();

    return (
        <li className="
            text-indigo-500 hover:text-slate-600 dark:hover:text-slate-400
            flex text-sm justify-start py-1 px-3 cursor-pointer
            "
            onClick={() => {
                navigate('/onboarding');
            }}
        >
            <FontAwesomeIcon icon={fas.faPlus} className={'my-auto'}/>
            &nbsp;
            {t('project.create')}
        </li>
    );
}